/** Worker-safe luminaire PDF label helpers (no HTTP / Redux imports). */

export interface LuminairePdfDisplay {
  manufacturer: string;
  /** Primary name shown in the PDF (catalogue product / variant when assigned). */
  displayName: string;
  /** Original Taman scene name; appended in parentheses when catalogue-assigned. */
  tamanName?: string;
  /** Catalogue variant lumen output when assigned; falls back to version light data. */
  lumenOutput?: number;
}

export function formatLuminaireLumenOutput(lumenOutput: number | undefined): string {
  if (lumenOutput == null || !Number.isFinite(lumenOutput) || lumenOutput <= 0) return '--';
  return `${Math.round(lumenOutput).toLocaleString()} lm`;
}

export function formatLuminairePdfHeader(display: LuminairePdfDisplay, shortId: string): string {
  const namePart =
    display.tamanName && display.tamanName !== display.displayName
      ? `${display.displayName} (${display.tamanName})`
      : display.displayName;
  return `${display.manufacturer}, ${namePart} (${shortId})`;
}

export function formatLuminairePdfName(display: LuminairePdfDisplay): string {
  if (display.tamanName && display.tamanName !== display.displayName) {
    return `${display.displayName} (${display.tamanName})`;
  }
  return display.displayName;
}
